import StarsBackground from "@/components/StarsBackground";
import NebulaBackground from "@/components/NebulaBackground";
import CosmicLightningLayer from "@/components/CosmicLightningLayer";
import EnergyParticles from "@/components/EnergyParticles";

interface CosmicLayoutProps {
  children: React.ReactNode;
}

const CosmicLayout = ({ children }: CosmicLayoutProps) => {
  return (
    <div
      className="min-h-screen flex flex-col relative overflow-x-hidden"
      style={{ backgroundColor: 'hsl(249 50% 4%)' }}
    >
      <div className="fixed inset-0 pointer-events-none" aria-hidden="true" role="presentation">
        <NebulaBackground />
        <EnergyParticles />
        <CosmicLightningLayer />
        <StarsBackground />
      </div>
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default CosmicLayout;
